import React from 'react';

// import about data
import { aboutData } from '../data';

const About = () => {
  // destructure about
  const { image, title, subtitle } = aboutData;
  return (
    <section
      id='about'
      className='my-[30px] pt-[50px] xl:mt-[100px]'
      data-aos='fade-up'
      data-aos-offset='350'
    >
      <div className='container mx-auto'>
        <div className='bg-accent-about rounded-[50px] min-h-[560px] px-12 pb-12 flex flex-col text-center xl:flex-row xl:items-center xl:text-left  xl:gap-x-[60px] xl:pb-0'>
          {/* image */}
          <div className='flex-1' data-aos='zoom-in-left'>
            <img src={image} alt='' />
          </div>
          {/* text */}
          <div className='flex-1 xl:pr-12'>
            <h2 className='h2 mb-10' data-aos='fade-up' data-aos-delay='300'>
              About us. <br></br> Islamic Learning
            </h2>
            <p
              className='max-w-[474px] font-semibold mx-auto xl:mx-0'
              data-aos='fade-up'
              data-aos-delay='400'
            >
              Dengan adanya website pembelajaran ini, diharapkan dapat membantu proses belajar anak sehingga anak bisa belajar tentang Asmaulhusna, 25 nabi dan rosul, doa-doa harian dan beberapa video animasi interaktif serta di harapkan dapat mengenal agama Islam dengan baik dan benar.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
